import NotificationsTemplate from "@/modules/notifications_template/components/NotificationsTemplate";
import NotificationsTemplateForm from "@/modules/notifications_template/components/NotificationsTemplateForm";

export default [
    {
        path: "/notifications-template",
        name: "NotificationsTemplate",
        component: NotificationsTemplate,
    },
    {
        path: "/notifications-template-form",
        name: "NotificationsTemplateForm",
        component: NotificationsTemplateForm,
    },
];



// WEBPACK FOOTER //
// ./src/modules/notifications_template/router/notifications_template.js